import React, { useCallback, useEffect, useState } from 'react';
import { getSortState, Translate, translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';

import { Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { NoData } from 'app/shared/components/no-data/NoData';
import { PageFilters } from 'app/shared/components/page-filters/PageFilters';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';
import { PaginationComponent } from 'app/shared/components/pagination/Pagination';
import { TableComponent } from 'app/shared/components/table-component/TableComponent';
import { IHeaderItem } from 'app/shared/interfaces/headerItemsInterface';
import { IListData } from 'app/shared/interfaces/listDataInterface';
import { ISearchTypes } from 'app/shared/interfaces/searchTypesInterface';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { Loading } from 'app/shared/util/loading';
import { ASC, DESC, SMALL_ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import { getEntities } from './block-screen.reducer';

export const BlockScreen = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const totalItems = useAppSelector(state => state.blockScreen.totalItems);
  const loading = useAppSelector(state => state.blockScreen.loading);
  const urlParams = new URLSearchParams(props.location.search);

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, SMALL_ITEMS_PER_PAGE, 'id'), props.location.search)
  );
  const blockScreenList = useAppSelector(state => state.blockScreen.entities);
  const [nameSearch, setNameSearch] = useState<string>(urlParams.get('nameSearch') || '');

  const headers: IHeaderItem[] = [
    {
      key: 'truckImplement',
      sortable: true,
      component: <Translate contentKey="fleetSenseApp.blockScreen.truckImplement" />,
    },
  ];

  const data: IListData[] = [
    { type: 'text', value: 'truckImplement?.licensePlate' },
    { type: 'deleteButton', value: 'id' },
  ];

  const searchTypes: ISearchTypes[] = [
    {
      label: translate('fleetSenseApp.blockScreen.home.searchLabel'),
      placeholder: translate('fleetSenseApp.blockScreen.home.search'),
      value: nameSearch,
      setValue: setNameSearch,
    },
  ];

  const getAllEntities = useCallback(() => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
        nameSearch,
      })
    );

    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}${endURL}`);
    }
  }, [paginationState]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = (_, page) =>
    setPaginationState({
      ...paginationState,
      activePage: page,
    });

  const setActivePage = () => {
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
  };

  useEffect(() => {
    getAllEntities();
  }, [getAllEntities]);

  const { match } = props;

  return (
    <Box sx={{ backgroundColor: 'primary.main', borderRadius: '8px', paddingTop: '16px', textAlign: 'center', padding: '24px' }}>
      <PageHeader
        headingId="block-screen--heading"
        headingDataCy="BlockScreenHeading"
        contentKey={'fleetSenseApp.blockScreen.home.title'}
        buttonTextKey={'fleetSenseApp.blockScreen.home.createLabel'}
        match={match}
      />

      <PageFilters setActivePage={setActivePage} searchTypes={searchTypes} showFilters={['filters']} />

      {!loading && <TableComponent listData={data} headers={headers} list={blockScreenList} match={match} sortFunction={sort} pagination={paginationState} />}
      {!loading && !blockScreenList.length && <NoData title="empresa" />}
      {loading && <Loading />}
      <PaginationComponent paginationState={paginationState} totalItems={totalItems} onChange={handlePagination} list={blockScreenList} />
    </Box>
  );
};

export default BlockScreen;
